import React from "react";
import { Button, Card, CardActions, CardContent, Chip, Divider, Stack, Typography } from "@mui/material";
import { formatMoney, toNumber } from "./shippingCostUtils";

const ShippingCostCard = ({ shippingCost, onEdit, onDelete }) => {
    const netValue = toNumber(shippingCost.price);
    const rate = toNumber(shippingCost.taxRate);
    const grossValue = netValue * (1 + rate / 100);

    return (
        <Card
            variant="outlined"
            sx={{
                borderRadius: 3,
                height: "100%",
                boxShadow: "0 8px 28px rgba(0,0,0,0.06)",
                transition: "transform .12s ease, box-shadow .12s ease",
                "&:hover": { transform: "translateY(-2px)", boxShadow: 6 },
            }}
        >
            <CardContent>
                <Stack direction="row" justifyContent="space-between" alignItems="flex-start">
                    <Typography variant="subtitle1" fontWeight={700} noWrap title={shippingCost.name}>
                        {shippingCost.name || "-"}
                    </Typography>
                    <Chip size="small" label={`${rate}%`} variant="outlined" />
                </Stack>

                <Divider sx={{ my: 1.25 }} />

                <Stack spacing={0.5}>
                    <Typography variant="body2">
                        <strong>Netto:</strong> {formatMoney(netValue)}
                    </Typography>
                    <Typography variant="body2">
                        <strong>Brutto:</strong> {formatMoney(grossValue)}
                    </Typography>

                    <Stack direction="row" spacing={1} sx={{ mt: 0.5 }} flexWrap="wrap">
                        <Chip
                            label={shippingCost.active ? "Aktiv" : "Inaktiv"}
                            size="small"
                            color={shippingCost.active ? "success" : "default"}
                            variant={shippingCost.active ? "filled" : "outlined"}
                        />
                    </Stack>
                </Stack>
            </CardContent>

            <CardActions sx={{ pt: 0, pb: 2, px: 2 }}>
                <Button size="small" onClick={() => onEdit(shippingCost)}>
                    Bearbeiten
                </Button>
                <Button size="small" color="error" onClick={() => onDelete(shippingCost)}>
                    Löschen
                </Button>
            </CardActions>
        </Card>
    );
};

export default ShippingCostCard;
